import { ApolloError, useMutation } from '@apollo/client'

import { MUTATION_INVITE_USER_TO_PROJECT } from '@libs/apollo/mutations'
import { PROJECT_ALL_ACL } from '@libs/apollo/queries'

import { MutationInviteUserToProjectArgs, UserInviteToProjectInput } from '@types'

interface Data {
  inviteUserToProject: boolean
}

export const useAddProjectRBAC = (): {
  addProjectRBAC: (input: UserInviteToProjectInput) => Promise<boolean | undefined>
  loading: boolean
  error: ApolloError | undefined
  data?: Data | null
} => {
  const [addProjectRBAC, { loading, error, data }] = useMutation<Data, MutationInviteUserToProjectArgs>(
    MUTATION_INVITE_USER_TO_PROJECT,
    {
      notifyOnNetworkStatusChange: true,
    },
  )

  const _addProjectRBAC = async (input: UserInviteToProjectInput): Promise<boolean | undefined> => {
    const result = await addProjectRBAC({
      variables: { input },
      refetchQueries: [
        {
          query: PROJECT_ALL_ACL,
          variables: {
            id: input.projectId,
          },
        },
      ],
      awaitRefetchQueries: true,
    })

    return result.data?.inviteUserToProject
  }

  return { addProjectRBAC: _addProjectRBAC, loading, error, data }
}
